import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45221b68"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45221b68')) {
      api.createRecord('45221b68', component.options)
    } else {
      api.reload('45221b68', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45221b68", function () {
      api.rerender('45221b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavTitle/index.vue"
export default component.exports